import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-panel-links',
  templateUrl: './patient-panel-links.component.html',
  styleUrls: ['./patient-panel-links.component.css']
})
export class PatientPanelLinksComponent implements OnInit {

  constructor() { }
  @Input() title;
  @Input() info;
  @Input() number;
  @Input() active;
  @Output() showAction = new EventEmitter();

  ngOnInit() {
  }

  showData(value) {
    this.showAction.emit(value);

  }


}
